<mat-sidenav-content
  class="side-nav-content-wrapper d-flex p-0 flex-column overflow-hidden"
  [class.opened-content]="isSidenavOpen"
  [class.collapsed-content]="!isSidenavOpen"
>
  @if(selectedItem){
  <div class="header-wrapper" [hidden]="isBreadcrumbHidden">
    <div class="accello-header1 breadcrum-wrapper">
      <app-breadcrumb class="h-100 d-flex" [data]="breadcrumb"></app-breadcrumb>
      <div class="d-flex align-items-center gap-2 pe-3" *ngIf="pageActions.length > 0">
        <ng-container *ngFor="let action of pageActions">
          <!-- Text-only info display (e.g. date range) -->
          <span *ngIf="action.isTextOnly" class="page-action-info">
            <img *ngIf="action.icon" [src]="action.icon | assetUrl" [alt]="action.label" class="page-action-info-icon" />
            {{ action.label }}
          </span>
          <!-- Icon-only button -->
          <div
            *ngIf="!action.isTextOnly && action.iconOnly"
            class="btn-icon-only-wrapper"
            [attr.data-tooltip]="action.label">
            <button
              class="btn-icon-only"
              (click)="onActionClick(action.key)"
              [disabled]="action.isLoading">
              <img *ngIf="action.icon && !action.isLoading" [src]="action.icon | assetUrl" [alt]="action.label" />
              <span *ngIf="action.isLoading" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            </button>
          </div>
          <!-- Dropdown action button -->
          <div
            *ngIf="!action.isTextOnly && !action.iconOnly && action.isDropdown && action.menuItems?.length"
            class="page-action-dropdown-wrapper"
            [class.open]="action['_open']"
            (click)="$event.stopPropagation()">
            <button
              type="button"
              class="page-action-dropdown-btn"
              [class.btn-accello-primary-light]="action.variant === 'primary'"
              [class.btn-accello-secondary]="action.variant !== 'primary'"
              [disabled]="action.isLoading"
              (click)="action['_open'] = !action['_open']">
              <span class="page-action-dropdown-label">{{ action.label }}</span>
              <svg class="page-action-dropdown-icon" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6 7L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span *ngIf="action.isLoading"
                class="spinner-border spinner-border-sm ms-2"
                aria-hidden="true"></span>
            </button>
            <div class="page-action-menu-panel" *ngIf="action['_open']">
              <button
                type="button"
                class="page-action-menu-item"
                *ngFor="let item of action.menuItems"
                [disabled]="item.disabled"
                (click)="onActionClick(item.key); action['_open'] = false">
                {{ item.label }}
              </button>
            </div>
          </div>
          <!-- Regular text + icon button -->
          <button
            *ngIf="!action.isTextOnly && !action.iconOnly && !action.isDropdown"
            [class.btn-accello-primary-light]="action.variant === 'primary'"
            [class.btn-accello-secondary]="action.variant !== 'primary'"
            (click)="onActionClick(action.key)"
            [disabled]="action.isLoading">
            <img *ngIf="action.icon" [src]="action.icon | assetUrl" [alt]="action.label" />
            <span>{{ action.label }}</span>
            <span *ngIf="action.isLoading"
              class="spinner-border spinner-border-sm mx-2"
              aria-hidden="true"></span>
          </button>
        </ng-container>
      </div>
      <!-- <div
        class="search-content-wrapper d-flex justify-content-center flex-column"
      >
        <div class="accello-primary-search d-flex mx-auto">
          <input
            type="text"
            placeholder="Search"
            class="search-input-wrapper general-text-5 content-search-color"
          />
          <button class="search-button content-search-color d-flex mx-auto">
            <img src="assets/images/virtusa-icons/search-icon.svg" class="general-text-5 content-search-color" width="12px" height="12px">
          </button>
        </div>
      </div> -->
    </div>
  </div>
  }
  <div class="overflow-auto generic-view flex-grow-1">
    <div #appGenericView></div>
  </div>
</mat-sidenav-content>
